const apiBaseUrl = import.meta.env.VITE_API_BASE_URL;

// Delete an image
export const deletePropertyMedia = async (
  propertyId: number,
  imageUrl: string,
  token: string,
): Promise<Response> => {
  const mediaId = imageUrl.split('/').slice(-1)[0];
  const response = await fetch(
    `${apiBaseUrl}/properties/${propertyId}/media/${mediaId}`,
    {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    },
  );

  if (!response.ok) {
    throw new Error(`Failed to delete property media: ${response.statusText}`);
  }

  return response;
};
